const loadingStorage = sessionStorage.getItem("closed-announcement-bar");
const closedBarsId = loadingStorage ? loadingStorage.split(",") : [];
document.querySelectorAll(".announcement-bar").forEach((bar) => {
    if (closedBarsId.includes(bar.getAttribute("id"))) return
    bar.style.display = "block";
})

function closeBar(){
    const announcementBarDiv = this.parentNode;
    const barId = announcementBarDiv.getAttribute("id");

    const currentStorage = sessionStorage.getItem("closed-announcement-bar");

    if (currentStorage) {
        sessionStorage.setItem("closed-announcement-bar", `${currentStorage},${barId}`);
    } else {
        sessionStorage.setItem("closed-announcement-bar", `${barId}`);
    }

    this.removeEventListener("click", closeBar);
    announcementBarDiv.style.display = "none";
}

document.querySelectorAll(".announcement-bar-close").forEach((element) => {
    element.addEventListener("click", closeBar);
});